const serviceTypes = ['Any', 'Expedite', 'Standard'];
const transportTypes = ['Van', 'Flatbed', 'Reefer'];
const equipmentSizeList = ['20ft', '40ft', '45ft', '48ft', '53ft'];
const weightUnitsList = ['t', 'oz', 'ton', 'g', 'lb', 'kg'];
const unitsList = [
  'A-Frame',
  'Bags',
  'Bales',
  'Barrel',
  'Basket',
  'Batteries',
  'Bins',
  'Box',
  'Break Bulk',
  'Bundle',
  'Cans',
  'Cart',
  'Carton',
  'Case',
  'Chest',
  'Container',
  'Crate',
  'Cylinder',
  'Drum',
  'Gallons',
  'Gaylords',
  'HalfPallets',
  'Hopper',
  'Jerricans',
  'Lift Van',
  'Loose',
  'Package',
  'Pails',
  'Pallet',
  'Piece',
  'Racks',
  'Reel',
  'Roll',
  'Skid',
  'Stacks',
  'Totes',
  'Truckload',
  'Tube',
  'Tubs',
  'U-Box',
  'Unit',
  'Vehicle',
  'Wheels',
];

export {
  serviceTypes,
  transportTypes,
  equipmentSizeList,
  weightUnitsList,
  unitsList,
};
